export default __webpack_public_path__ + "static/media/double-portrait.09865522.svg";